<template>
  <div>
    <el-card
      v-loading="isLoading"
      shadow="never"
    >
      <BudgetsTable :budgets="budgets" />
      <el-pagination
        class="text-center pt-3"
        :current-page.sync="budgets.page"
        :page-size.sync="budgets.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="budgets.total"
        @size-change="reload"
        @current-change="reload"
      />
    </el-card>
    <BudgetEditDialog
      v-if="isShowEditDialog"
      :is-show.sync="isShowEditDialog"
    />
  </div>
</template>

<script>
import BudgetsTable from '@/components/Application/Sales/Budgets/BudgetsTable'
import BudgetEditDialog from '@/components/Application/Sales/Budgets/BudgetEditDialog'
export default {
  components: {
    BudgetsTable,
    BudgetEditDialog
  },
  data () {
    return {
      actions: [
        {
          name: 'Create',
          icon: ['fal', 'plus'],
          event: () => {
            this.isShowEditDialog = true
          }
        },
        {
          name: 'Refresh',
          icon: ['fal', 'sync'],
          event: this.reload
        }
      ],
      budgets: [],
      isLoading: true,
      isShowEditDialog: false
    }
  },
  created () {
    this.loadTable()
  },
  methods: {
    loadTable () {
      //
      this.isLoading = false
    },
    async reload () {
      this.isLoading = true

      try {
        await this.budgets.reload()
      } catch {
        this.$message.error('Failed to load Budgets')
      }

      this.isLoading = false
    }
  }
}
</script>

<style>

</style>
